import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

interface SEOProps {
    title?: string;
    description?: string;
    keywords?: string;
    image?: string;
    url?: string;
    type?: string;
}

const SEO: React.FC<SEOProps> = ({
    title,
    description,
    keywords,
    image = 'https://bousanmtechnology.com/og-image.png',
    url = 'https://bousanmtechnology.com',
    type = 'website',
}) => {
    const { t, i18n } = useTranslation();

    const siteTitle = t('seo.siteTitle', 'Bousanm Technology');
    const fullTitle = title ? `${title} | ${siteTitle}` : t('seo.defaultTitle', 'Bousanm Technology - Global Logistics & Software');
    const metaDescription = description || t('seo.defaultDescription', 'Global software development, e-commerce infrastructure, and logistics solutions.');
    const metaKeywords = keywords || t('seo.defaultKeywords', 'software development, logistics, shipping, e-commerce, Caribbean, Latin America');

    return (
        <Helmet>
            {/* Standard metadata tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />
            <link rel="canonical" href={`${url}${window.location.pathname}`} />
            <html lang={i18n.language} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={`${url}${window.location.pathname}`} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

export default SEO;
